export const ARE_YOU_SURE_YOU_WANT_TO_TEXT = {
    description: 'Warning message',
    defaultMessage: 'Are you sure you want to',
    id: 'oe.warnings.areYouSureTo'
};
export const DELETE_THIS_EVENT_TEXT = {
    description: 'Warning message',
    defaultMessage: 'delete this event',
    id: 'oe.event.deleteThisEvent'
};
export const DELETE_EVENT_TEXT = {
    description: 'Label text',
    defaultMessage: 'Delete Event',
    id: 'oe.event.deleteEvent'
};
export const REINSTATE_THIS_EVENT_TEXT = {
    id: 'oe.alerts.reinstateThisEvent',
    description: 'Alert message',
    defaultMessage: 'reinstate this event'
};
export const CANCEL_THIS_EVENT_TEXT = {
    id: 'oe.alerts.cancelThisEvent',
    description: 'Alert message',
    defaultMessage: 'cancel this event'
};
export const REINSTATE_EVENT_TEXT = {
    id: 'oe.meetings.reinstateEvent',
    description: 'Button label',
    defaultMessage: 'Reinstate Event'
};
export const CANCEL_EVENT_TEXT = {
    id: 'oe.meetings.cancelEvent',
    description: 'Button label',
    defaultMessage: 'Cancel Event'
};
export const NO_GO_BACK_TEXT = {
    id: 'oe.common.noGoBack',
    description: 'Button label',
    defaultMessage: 'No, go back'
};
export const SETTING_UP_BLUEPRINT_ALERT_TEXT = {
    id: 'oe.alert.settingUpBlueprint',
    description: 'Confirm message',
    defaultMessage: 'We are setting up the event according to the Blueprint.'
};
export const OK_TEXT = {
    id: 'oe.common.btn.ok',
    description: 'Button Label',
    defaultMessage: 'Ok'
};
export const SALESFORCE_SYNC_FAILED_TITLE = {
    id: 'oe.event.salesforceSyncFailedTitle',
    description: 'Alert title shown when an Edit Event save did not propagate to the linked Salesforce Order',
    defaultMessage: 'Salesforce Order not updated'
};
